import {Elm} from '../DividendCalculator'

document.addEventListener('DOMContentLoaded', () => {
    const container = document.getElementById('dividend-calculator');

    Elm.DividendCalculator.init({
        node: container,
        flags: {
            years: [container.dataset.currentYear, container.dataset.nextYear],
            corporateTax: [container.dataset.corporateTax, container.dataset.corporateTaxNext],
            dividendTax: [container.dataset.dividendTax, container.dataset.dividendTaxNext],
            standardRuleLimit: [container.dataset.standardRuleLimit, container.dataset.standardRuleLimitNext],
            mainRuleLowerLimit: [container.dataset.mainRuleLowerLimit, container.dataset.mainRuleLowerLimitNext],
            mainRuleUpperLimit: [container.dataset.mainRuleUpperLimit, container.dataset.mainRuleUpperLimitNext],
            mainRulePercent: container.dataset.mainRulePercent
        }
    });
});
